import { render } from "./RowColComponent.vue?vue&type=template&id=4ad010a1"
import script from "./RowColComponent.vue?vue&type=script&lang=js"
export * from "./RowColComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__